import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-familiars',
  templateUrl: './familiars.component.html',
  styleUrls: ['./familiars.component.scss']
})
export class FamiliarsComponent {
  dataFamiliars: any[] = [];

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialog: MatDialog,
    public apiUsersServices: UsersService
  ) { }

  ngOnInit(): void {
    this.getDataFamiliars();
  }

  getDataFamiliars() {
    this.loaderService.show();

    this.apiUsersServices.getUserFamiliars().subscribe({
      next: (value) => {
        if (value.status) {
          this.dataFamiliars = value.data;
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: "Hubo un error al procesar tu solicitud" }
          });
        }

        this.loaderService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loaderService.hide();
      }
    });
  }

  addFamily() {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogAddFamily, {
      width: isMobile ? '90vw' : '350px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      data: {
        familiar: null
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getDataFamiliars();
    });

  }

  formatBirthdate(value: any): string {
    if (!value) {
      return '';
    }

    const valueString = String(value);
    const match = valueString.match(
      /^(\d{4})-(\d{2})-(\d{2})/
    );

    if (match) {
      return `${match[3]}/${match[2]}/${match[1]}`;
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  editFamily(familiar: any) {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogAddFamily, {
      width: isMobile ? '90vw' : '350px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      data: {
        familiar: familiar
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getDataFamiliars();
    });

  }

  deleteFamily(id: number) {

    this.loaderService.show();

    this.apiUsersServices.deleteUserFamiliar({
      user_familiar_id: id
    }).subscribe({
      next: (value) => {

        if (value.status) {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: "Familiar eliminado correctamente" }
          });

          this.getDataFamiliars();
        }

        this.loaderService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loaderService.hide();
      }
    });
  }
}

@Component({
  selector: 'dialog-add-family',
  templateUrl: 'dialog-add-family.html',
  styleUrls: ['dialog-add-family.scss']
})

export class DialogAddFamily {
  prevData: any = null;
  familyForm: any;
  familiarPositions: any[] = [];

  constructor(
    private loaderService: LoaderService,
    public dialogRef: MatDialogRef<DialogAddFamily>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private coreService: CoreService,
    public apiUsersServices: UsersService,
    public formBuilder: FormBuilder
  ) {

    if (data.familiar != null) {
      this.prevData = data.familiar;
      // console.log(this.prevData)
    }

    this.createForm();
    this.getFamiliarPositions();
  }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createForm() {
    this.familyForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      last_name: ['', []],
      last_name2: ['', []],
      familiar_position_id: ['', [Validators.required]],
      birthdate: ['', [Validators.required]],
      active: [true],
      alert_active: [true]
    });

    if (this.prevData != null) {
      this.familyForm.patchValue({
        name: this.prevData.first_name,
        last_name: this.prevData.last_name,
        last_name2: this.prevData.last_name2,
        familiar_position_id: this.prevData.familiar_position_id,
        birthdate: this.formatBirthdateForInput(
          this.prevData.birthdate
        ),
        active: this.prevData.active,
        alert_active: this.prevData.alert_active
      });
    }
  }

  getFamiliarPositions() {
    this.loaderService.show();

    this.apiUsersServices.getFamiliarPositions().subscribe({
      next: (value) => {
        if (value.status) {
          this.familiarPositions = value.data;
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loaderService.hide();
      }
    });
  }

  private formatBirthdate(value: any): string {
    if (!value) return '';

    const valueString = String(value);

    // Si ya viene como yyyy-MM-dd
    const match = valueString.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  saveFamily() {
    const dataForm = {
      ...this.familyForm.value,
      birthdate: this.formatBirthdate(this.familyForm.value.birthdate)
    };
    if (this.prevData == null) {
      this.loaderService.show();
      this.apiUsersServices.createUserFamiliar(dataForm).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: value.message
            }
          });
          if (value.status) {
            this.dialogRef.close(true);
          }
          this.loaderService.hide();
        },
        error: (err) => {
          console.error(err);
          this.loaderService.hide();
        }
      });
    }
    else {
      dataForm.user_familiar_id = this.prevData.id;
      this.loaderService.show();
      this.apiUsersServices.updateUserFamiliar(dataForm).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: value.message
            }
          });
          if (value.status) {
            this.dialogRef.close(true);
          }
          this.loaderService.hide();
        },
        error: (err) => {
          console.error(err);
          this.loaderService.hide();
        }
      });
    }
  }

  private formatBirthdateForInput(value: any): string {
    if (!value) return '';

    const valueString = String(value);

    const match = valueString.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
  }

  get name() { return this.familyForm.get('name'); }

  getErrorMessage(control: string): string {
    const controlErrors = this.familyForm.get(control)?.errors;
    if (!controlErrors) return '';

    if (controlErrors.required) return 'Este campo es requerido';
    if (controlErrors.minlength) return 'Longitud inválida';
    return '';
  }
}
